import React from 'react';
import { Link } from 'react-router-dom';
import AssessmentCard, { AssessmentCardSkeleton } from './AssessmentCard';

/**
 * DashboardAssessmentsSection
 *
 * Props:
 * - assessmentsLoading: boolean
 * - assessmentsError: string | null
 * - recentAssessments: array
 * - userEmail: string | undefined
 */
const DashboardAssessmentsSection = ({
  assessmentsLoading,
  assessmentsError,
  recentAssessments,
  userEmail
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 shadow rounded-lg">
      <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">
            Your Assessments
          </h3>
          <Link
            to="/assessment/self-guided"
            className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-sm font-medium"
          >
            New Assessment →
          </Link>
        </div>
      </div>

      <div className="p-6">
        {assessmentsLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(3)].map((_, i) => (
              <AssessmentCardSkeleton key={i} />
            ))}
          </div>
        ) : assessmentsError ? (
          <div className="text-center py-12">
            <div className="text-red-600 dark:text-red-400 mb-4 font-semibold">
              ⚠️ {assessmentsError}
            </div>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Check the browser console for detailed error information
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-blue-600 hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-600 text-white px-4 py-2 rounded-lg"
            >
              Retry
            </button>
          </div>
        ) : recentAssessments.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {recentAssessments.map((assessment) => (
              <AssessmentCard
                key={assessment.id}
                assessment={assessment}
                userEmail={userEmail}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <svg
              className="mx-auto h-12 w-12 text-gray-400 dark:text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white">
              No assessments yet
            </h3>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Get started by completing your first energy assessment
            </p>
            <div className="mt-6">
              <Link
                to="/assessment/self-guided"
                className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-600"
              >
                <svg
                  className="mr-2 -ml-1 h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                    clipRule="evenodd"
                  />
                </svg>
                Start Assessment
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardAssessmentsSection;


